import { Link as WouterLink } from "wouter";

interface SafeLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

/**
 * A wrapper around Wouter's Link component that ensures URLs don't have double slashes
 */
export function SafeLink({ href, children, className, onClick }: SafeLinkProps) {
  // Ensure no double slashes in URL paths
  const fixedHref = href.replace(/\/+/g, '/');
  
  return (
    <WouterLink 
      href={fixedHref} 
      className={className}
      onClick={onClick}
    >
      {children}
    </WouterLink>
  );
}